import CharityDonationRepository from './CharityDonationRepository';

export default CharityDonationRepository;
